export const siteKey = 1;
export const secretKey = "caViMEzciS7PyJPYdFPcyIHsLdkeEHhqLs9Y5bgD";

export const domainURL = {
    //BASE: "http://127.0.0.1:3333/",
    BASE: "https://e-tokopkk.bantenprov.go.id/service/"
};

